/* src/app/vehicle/partials/vehicledetail-form/vehicledetail-form.component.scss */
select option:disabled {
  color: #ccc;
  font-style: italic;
}
/*# sourceMappingURL=vehicledetail-form.component.css.map */
